@if(show) {
<div class="fixed top-6 right-6 z-[9999]">
  <app-alert [title]="toastTitle" [message]="toastMessage" [type]="toastType" [duration]="4000" role="alert"
    aria-live="assertive">
  </app-alert>
</div>
}

<div class="auth-desktop-layout min-h-screen bg-white">

  <!-- ===== PANEL IZQUIERDO: Hero visual ===== -->
  <div class="relative hidden w-1/2 overflow-hidden bg-[#0F0F3D] md:flex">
    <img src="assets/images/fondo-main.svg" alt="" class="absolute inset-0 h-full w-full object-cover" />
    <img src="assets/images/fondo 1.svg" alt=""
      class="absolute inset-0 h-full w-full object-cover mix-blend-screen opacity-100" />

    <div class="relative z-10 flex h-full w-full flex-col justify-between px-6 py-8 lg:pl-20 lg:pr-12 lg:py-12">
      <div>
        <img src="assets/images/ardia.svg" alt="ARDIA" class="h-7 brightness-0 invert lg:h-10" />
      </div>

      <div class="flex flex-1 items-center">
        <h1
          class="text-3xl font-extrabold leading-[1.15] tracking-tight text-white md:text-4xl lg:text-[3.2rem] xl:text-[3.5rem]"
          style="text-shadow: 0 1px 8px rgba(0,0,0,0.18);">
          La plataforma de<br>
          <span class="text-[#60A5FA]">Agentes<br>Inteligentes</span>,<br>
          conectada a los<br>
          datos de tu<br>
          empresa en<br>
          tiempo real.
        </h1>
      </div>

      <div class="flex w-full items-center gap-4">
        <div class="h-px flex-1 bg-white/30"></div>
        <p class="whitespace-nowrap text-[11px] font-semibold uppercase tracking-[0.3em] text-white/80">Inteligencia
          artificial para empresas</p>
        <div class="h-px flex-1 bg-white/30"></div>
      </div>
    </div>
  </div>

  <!-- ===== PANEL DERECHO: Formulario ===== -->
  <div class="flex w-full items-center justify-center px-6 py-10 md:w-1/2">

    @if(isProcessingMicrosoftLogin) {
    <div class="flex w-full max-w-[420px] flex-col items-center justify-center">
      <div class="mb-4 flex space-x-1.5">
        <div class="h-2.5 w-2.5 animate-bounce rounded-full bg-[var(--color-brand-400)]" style="animation-delay: 0s">
        </div>
        <div class="h-2.5 w-2.5 animate-bounce rounded-full bg-[var(--color-brand-400)]" style="animation-delay: 0.15s">
        </div>
        <div class="h-2.5 w-2.5 animate-bounce rounded-full bg-[var(--color-brand-400)]" style="animation-delay: 0.3s">
        </div>
      </div>
      <p class="text-center text-[15px] text-[var(--color-gray-600)]">
        Procesando inicio de sesión con Microsoft...
      </p>
    </div>
    } @else {
    <div class="w-full" [class]="activeTab === 'register' ? 'max-w-[540px]' : 'max-w-[420px]'">

      @if(activeTab !== 'forgot') {
      <div class="mb-10 flex items-center gap-8">
        <button type="button" (click)="switchTab('login')"
          [class]="activeTab === 'login'
            ? 'text-[15px] font-semibold text-[var(--color-brand-400)] border-b-2 border-[var(--color-brand-400)] pb-2.5'
            : 'text-[15px] font-medium text-[#9CA3AF] hover:text-[#6B7280] pb-2.5 border-b-2 border-transparent transition-colors cursor-pointer'">Iniciar
          Sesión</button>
        <button type="button" (click)="switchTab('register')"
          [class]="activeTab === 'register'
            ? 'text-[15px] font-semibold text-[var(--color-brand-400)] border-b-2 border-[var(--color-brand-400)] pb-2.5'
            : 'text-[15px] font-medium text-[#9CA3AF] hover:text-[#6B7280] pb-2.5 border-b-2 border-transparent transition-colors cursor-pointer'">Crear Cuenta</button>
      </div>
      }

      @if(activeTab === 'login') {
      <div class="tab-content-animate">
        <h2 class="mb-1.5 text-[28px] font-bold text-[#111827]">Bienvenido a ARDIA</h2>
        <p class="mb-8 text-[15px] text-[#6B7280]">Gestiona tus agentes inteligentes en un solo lugar.</p>

        <form [formGroup]="loginForm" (ngSubmit)="login()" class="flex flex-col gap-5"
          aria-labelledby="login-form-heading">
          <h3 id="login-form-heading" class="sr-only">Formulario de inicio de sesión</h3>

          <div>
            <label for="username" class="mb-2 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">
              Correo electrónico
            </label>
            <input #usernameInput id="username" name="username" type="email" required tabindex="1"
              placeholder="nombre@empresa.com"
              class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3.5 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30"
              aria-required="true" formControlName="username" (input)="convertToLowercase($event)"
              style="text-transform: lowercase;" aria-describedby="username-error" autocomplete="email" />
            <div id="username-error" class="mt-1.5 text-xs text-[var(--color-error-500)]" aria-live="polite">
              @if(loginForm.controls['username'].invalid && loginForm.controls['username'].touched) {
              Introduce un correo electrónico válido
              }
            </div>
          </div>

          <div>
            <label for="password" class="mb-2 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">
              Contraseña
            </label>
            <div class="relative">
              <input #passwordInput id="password" name="password" [type]="showPassword ? 'text' : 'password'" required
                tabindex="2" placeholder="••••••••••"
                class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3.5 pr-12 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30"
                aria-required="true" formControlName="password" aria-describedby="password-error"
                autocomplete="current-password" />
              @if (loginForm.get('password')?.value && loginForm.get('password')?.value.length > 0) {
              <button type="button" tabindex="-1" (click)="togglePasswordVisibility()"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-[#9CA3AF] transition-colors hover:text-[#6B7280] focus:outline-none"
                aria-label="Mostrar/ocultar contraseña">
                @if (showPassword) {
                <fa-icon [icon]="faEyeSlash" class="text-sm"></fa-icon>
                } @else {
                <fa-icon [icon]="faEye" class="text-sm"></fa-icon>
                }
              </button>
              }
            </div>
            <div id="password-error" class="mt-1.5 text-xs text-[var(--color-error-500)]" aria-live="polite">
              @if(loginForm.controls['password'].invalid && loginForm.controls['password'].touched) {
              @if(loginForm.controls['password'].errors?.['required']) {
              La contraseña es obligatoria
              }
              @else if(loginForm.controls['password'].errors?.['minlength']) {
              La contraseña debe tener al menos 8 caracteres
              }
              }
            </div>
          </div>

          <div class="flex items-center justify-between">
            <label class="flex cursor-pointer items-center gap-2">
              <input type="checkbox" [(ngModel)]="rememberSession" [ngModelOptions]="{standalone: true}"
                class="h-4 w-4 cursor-pointer rounded border-[#D1D5DB] text-[var(--color-brand-400)] focus:ring-[var(--color-brand-400)]/30" />
              <span class="text-[13px] text-[#6B7280]">Recordar sesión</span>
            </label>
            <button type="button" tabindex="6" (click)="switchTab('forgot')"
              class="cursor-pointer text-[13px] font-semibold text-[var(--color-brand-400)] hover:underline"
              aria-label="Recuperar contraseña">¿Olvidaste tu contraseña?</button>
          </div>

          <button type="submit" tabindex="3"
            class="flex h-[50px] w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-[var(--color-brand-400)] text-[15px] font-semibold text-white shadow-sm transition-colors hover:bg-[var(--color-brand-500)] disabled:cursor-not-allowed disabled:bg-[#D1D5DB]"
            aria-label="Iniciar sesión">
            <span>Continuar</span>
            <fa-icon [icon]="faChevronRight" class="text-xs"></fa-icon>
          </button>
        </form>

        <div class="my-7 flex items-center gap-4">
          <div class="h-px flex-1 bg-[#E5E7EB]"></div>
          <span class="text-[11px] font-semibold uppercase tracking-wider text-[#9CA3AF]">O acceder con</span>
          <div class="h-px flex-1 bg-[#E5E7EB]"></div>
        </div>

        <div class="grid grid-cols-2 gap-3">
          <button type="button" tabindex="4"
            class="flex h-[46px] cursor-pointer items-center justify-center gap-2.5 rounded-lg border border-[#E5E7EB] bg-white text-[#374151] transition-colors hover:bg-[#F9FAFB]"
            aria-label="Iniciar sesión con Microsoft" (click)="loginWithMicrosoft($event)"
            [disabled]="isMicrosoftLoginLoading">
            @if(isMicrosoftLoginLoading) {
            <div
              class="h-4 w-4 animate-spin rounded-full border-2 border-[var(--color-brand-400)] border-t-transparent">
            </div>
            <span class="text-[13px] font-medium">Conectando...</span>
            } @else {
            <fa-icon [icon]="faMicrosoft" class="text-base"></fa-icon>
            <span class="text-[13px] font-medium">Microsoft</span>
            }
          </button>
          <button type="button"
            class="flex h-[46px] cursor-pointer items-center justify-center gap-2.5 rounded-lg border border-[#E5E7EB] bg-white text-[#374151] transition-colors hover:bg-[#F9FAFB]"
            disabled>
            <svg class="w-5 h-5 text-[#6B7280]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
            </svg>
            <span class="text-[13px] font-medium">SSO</span>
          </button>
        </div>

        <div class="mb-8 mt-8">
          <div class="h-px w-full bg-[#E5E7EB]/50"></div>
        </div>

        <div class="text-center">
          <p class="mb-3 text-[13px] text-[#9CA3AF]">¿Aún no eres cliente?</p>
          <a href="https://outlook.office.com/book/DemoArdia@sdi.es/?ismsaljsauthenabled=true" target="_blank"
            rel="noopener noreferrer"
            class="inline-flex h-[50px] w-full cursor-pointer items-center justify-center gap-2 rounded-xl border-2 border-[var(--color-brand-400)] bg-transparent text-[14px] font-bold uppercase tracking-wider text-[var(--color-brand-400)] no-underline transition-colors hover:bg-[var(--color-brand-400)]/5"
            aria-label="Solicitar demo">
            SOLICITAR DEMO
            <fa-icon [icon]="faChevronRight" class="text-xs"></fa-icon>
          </a>
        </div>
      </div>

      } @else if(activeTab === 'register') {
      <div class="tab-content-animate">

        <h2 class="mb-1.5 text-[28px] font-bold text-[#111827]">Crear cuenta profesional</h2>
        <p class="mb-8 text-[15px] text-[#6B7280]">Regístrate para acceder a tus agentes conectados.</p>

        <form [formGroup]="registerForm" (ngSubmit)="register()" class="flex flex-col gap-4"
          aria-labelledby="register-form-heading">
          <h3 id="register-form-heading" class="sr-only">Formulario de registro</h3>

          <div class="flex flex-col gap-3 sm:flex-row">
            <div class="w-full sm:w-1/2">
              <label for="reg-name"
                class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Nombre *</label>
              <input id="reg-name" type="text" formControlName="name" required placeholder="Tu nombre"
                class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
              <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                @if(registerForm.get('name')?.invalid && registerForm.get('name')?.touched) { Introduce un nombre válido
                }
              </div>
            </div>
            <div class="w-full sm:w-1/2">
              <label for="reg-lastName"
                class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Apellidos</label>
              <input id="reg-lastName" type="text" formControlName="lastName" placeholder="Tus apellidos"
                class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
            </div>
          </div>

          <div class="flex flex-col gap-3 sm:flex-row">
            <div class="w-full sm:w-1/2">
              <label for="reg-email"
                class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Email Profesional
                *</label>
              <input id="reg-email" type="email" formControlName="email" required autocomplete="email"
                placeholder="nombre@empresa.com" (input)="convertRegisterToLowercase($event, 'email')"
                style="text-transform: lowercase;"
                class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
              <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                @if(registerForm.get('email')?.invalid && registerForm.get('email')?.touched) { Introduce un correo
                electrónico válido }
              </div>
            </div>
            <div class="w-full sm:w-1/2">
              <label for="reg-phone"
                class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Teléfono
                *</label>
              <div class="relative">
                <span class="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#9CA3AF]">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                  </svg>
                </span>
                <input id="reg-phone" type="tel" formControlName="phone" required placeholder="+34 600 000 000"
                  class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] pl-10 pr-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
              </div>
              <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                @if(registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched) { El formato del teléfono
                no es válido }
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-3 sm:flex-row">
            <div class="w-full sm:w-1/2">
              <label for="reg-companyName"
                class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Empresa *</label>
              <input id="reg-companyName" type="text" formControlName="companyName" required
                placeholder="Nombre de la empresa"
                class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
              <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                @if(registerForm.get('companyName')?.invalid && registerForm.get('companyName')?.touched) { Introduce un
                nombre de empresa válido }
              </div>
            </div>
            <div class="w-full sm:w-1/2">
              <label for="reg-nif"
                class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">NIF *</label>
              <input id="reg-nif" type="text" formControlName="nif" required placeholder="B12345678"
                class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
              <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                @if(registerForm.get('nif')?.invalid && registerForm.get('nif')?.touched) { Introduce un NIF válido }
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-3 sm:flex-row">
            <div class="w-full sm:w-1/2">
              <label for="reg-password"
                class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Contraseña
                *</label>
              <div class="relative">
	                <input id="reg-password" [type]="showRegisterPassword ? 'text' : 'password'" formControlName="password"
	                  required placeholder="Contraseña segura"
                  class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 pr-12 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                <button type="button" tabindex="-1" (click)="toggleRegisterPassword()"
                  class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-[#9CA3AF] transition-colors hover:text-[#6B7280] focus:outline-none"
                  aria-label="Mostrar/ocultar contraseña">
                  @if(showRegisterPassword) {
                  <fa-icon [icon]="faEyeSlash" class="text-sm"></fa-icon>
                  } @else {
                  <fa-icon [icon]="faEye" class="text-sm"></fa-icon>
                  }
                </button>
              </div>
            </div>
            <div class="w-full sm:w-1/2">
              <label for="reg-passwordConfirmation"
                class="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">Confirmar
                Contraseña *</label>
              <div class="relative">
                <input id="reg-passwordConfirmation" [type]="showRegisterPasswordConfirm ? 'text' : 'password'"
                  formControlName="passwordConfirmation" required placeholder="Repite la contraseña"
                  class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 pr-12 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30" />
                <button type="button" tabindex="-1" (click)="toggleRegisterPasswordConfirm()"
                  class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-[#9CA3AF] transition-colors hover:text-[#6B7280] focus:outline-none"
                  aria-label="Mostrar/ocultar contraseña">
                  @if(showRegisterPasswordConfirm) {
                  <fa-icon [icon]="faEyeSlash" class="text-sm"></fa-icon>
                  } @else {
                  <fa-icon [icon]="faEye" class="text-sm"></fa-icon>
                  }
                </button>
              </div>
              <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
                @if(registerForm.get('passwordConfirmation')?.invalid &&
                registerForm.get('passwordConfirmation')?.touched) {
                @if(registerForm.get('passwordConfirmation')?.errors?.['required']) { Debes confirmar tu contraseña }
                @else if(registerForm.get('passwordConfirmation')?.errors?.['passwordMismatch']) { Las contraseñas no
                coinciden }
                }
              </div>
            </div>
          </div>

          @if (registerForm.get('password')?.value) {
          <div class="mt-1 space-y-2" aria-live="polite">
            <p class="text-xs font-medium text-[#6B7280]">Requisitos:</p>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().minLength"
                [class.bg-red-200]="!getPasswordRequirements().minLength">
                @if (getPasswordRequirements().minLength) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().minLength"
                [class.text-gray-400]="!getPasswordRequirements().minLength">Mínimo 8 caracteres</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasUppercase"
                [class.bg-red-200]="!getPasswordRequirements().hasUppercase">
                @if (getPasswordRequirements().hasUppercase) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasUppercase"
                [class.text-gray-400]="!getPasswordRequirements().hasUppercase">Una mayúscula (A-Z)</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasLowercase"
                [class.bg-red-200]="!getPasswordRequirements().hasLowercase">
                @if (getPasswordRequirements().hasLowercase) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasLowercase"
                [class.text-gray-400]="!getPasswordRequirements().hasLowercase">Una minúscula (a-z)</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasNumber"
                [class.bg-red-200]="!getPasswordRequirements().hasNumber">
                @if (getPasswordRequirements().hasNumber) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasNumber"
                [class.text-gray-400]="!getPasswordRequirements().hasNumber">Un número (0-9)</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasSpecial"
                [class.bg-red-200]="!getPasswordRequirements().hasSpecial">
                @if (getPasswordRequirements().hasSpecial) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasSpecial"
                [class.text-gray-400]="!getPasswordRequirements().hasSpecial">Un carácter especial (!&#64;#$%etc)</span>
            </div>
          </div>
          }

          <div class="mt-1">
            <div class="flex items-start gap-2.5">
              <input type="checkbox" formControlName="acceptTerms" id="acceptTermsLogin"
                class="mt-0.5 h-4 w-4 cursor-pointer rounded border-[#D1D5DB] text-[var(--color-brand-400)] focus:ring-[var(--color-brand-400)]/30" />
              <span class="text-[13px] leading-snug text-[#6B7280]">
                <label for="acceptTermsLogin" class="cursor-pointer">Acepto las </label><a
                  (click)="openLegalModal($event, 'Condiciones de servicio')"
                  class="cursor-pointer font-semibold text-[var(--color-brand-400)] hover:underline">Condiciones de
                  servicio</a><label for="acceptTermsLogin" class="cursor-pointer"> y la </label><a
                  (click)="openLegalModal($event, 'Política de privacidad')"
                  class="cursor-pointer font-semibold text-[var(--color-brand-400)] hover:underline">Política de
                  privacidad</a><label for="acceptTermsLogin" class="cursor-pointer">.</label>
              </span>
            </div>
            <div class="mt-1 text-[10px] text-[var(--color-error-500)] sm:text-xs" aria-live="polite">
              @if(registerForm.get('acceptTerms')?.invalid && registerForm.get('acceptTerms')?.touched) { Debes aceptar
              las condiciones para continuar }
            </div>
          </div>

          <div class="h-px w-full bg-[#E5E7EB]/40"></div>

          <button type="submit"
            class="mt-2 flex h-[50px] w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-[var(--color-brand-400)] text-[15px] font-semibold text-white shadow-sm transition-colors hover:bg-[var(--color-brand-500)] disabled:cursor-not-allowed disabled:bg-[#D1D5DB]"
            [disabled]="isRegistering" aria-label="Registrarse">
            @if(isRegistering) {
            <div class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
            <span>Registrando...</span>
            } @else {
            <span>Continuar</span>
            <fa-icon [icon]="faChevronRight" class="text-xs"></fa-icon>
            }
          </button>
        </form>

        <div class="mt-6">
          <button type="button" (click)="switchTab('login')"
            class="flex cursor-pointer items-center text-[14px] font-semibold text-[var(--color-brand-400)] hover:underline"
            aria-label="Ya tengo cuenta">
            Ya tengo cuenta
            <fa-icon [icon]="faChevronRight" class="ml-1 text-sm"></fa-icon>
          </button>
        </div>
      </div>

      } @else if(activeTab === 'forgot') {
      <div class="tab-content-animate">

        @if(!recoveryEmailSent) {
        <p class="mb-2 text-[16px] text-[#111827]">Recupera tu acceso</p>
        <h2 class="mb-3 text-[28px] font-bold text-[#111827]">¿Olvidaste tu contraseña?</h2>
        <p class="mb-8 text-[15px] text-[#6B7280]">Introduce tu correo y te enviaremos un enlace para restablecer tu
          contraseña.</p>

        <form [formGroup]="forgotPasswordForm" (ngSubmit)="requestPasswordReset()" class="flex flex-col gap-5">
          <div>
            <label for="forgot-email"
              class="mb-2 block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280]">
              Correo electrónico
            </label>
            <input id="forgot-email" type="email" formControlName="email" required placeholder="nombre@empresa.com"
              class="w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3.5 text-[14px] text-[#111827] placeholder-[#9CA3AF] transition-colors focus:border-[var(--color-brand-400)] focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)]/30"
              (input)="convertForgotToLowercase($event)" style="text-transform: lowercase;" autocomplete="email" />
            <div class="mt-1.5 text-xs text-[var(--color-error-500)]" aria-live="polite">
              @if(forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched) {
              Introduce un correo electrónico válido
              }
            </div>
          </div>

          <button type="submit"
            class="flex h-[50px] w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-[var(--color-brand-400)] text-[15px] font-semibold text-white shadow-sm transition-colors hover:bg-[var(--color-brand-500)] disabled:cursor-not-allowed disabled:bg-[#D1D5DB]"
            [disabled]="isSendingRecovery">
            @if(isSendingRecovery) {
            <div class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
            <span>Enviando...</span>
            } @else {
            <span>Continuar</span>
            <fa-icon [icon]="faChevronRight" class="text-xs"></fa-icon>
            }
          </button>
        </form>
        } @else {
        <div class="text-center">
          <div
            class="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--color-brand-400)]/10">
            <svg class="h-8 w-8 text-[var(--color-brand-400)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
            </svg>
          </div>
          <h2 class="mb-3 text-[24px] font-bold text-[#111827]">Revisa tu correo</h2>
          <p class="mb-2 text-[15px] text-[#6B7280]">Hemos enviado un enlace de recuperación a:</p>
          <p class="mb-6 text-[15px] font-semibold text-[#111827]">{{ recoveryEmail }}</p>
          <p class="text-[13px] text-[#9CA3AF]">Si no recibes el correo en unos minutos, revisa tu carpeta de spam.</p>
        </div>
        }

        <div class="mt-8">
          <button type="button" (click)="backToLoginFromForgot()"
            class="flex cursor-pointer items-center text-[14px] font-semibold text-[var(--color-brand-400)] hover:underline">
            Volver al inicio de sesión
            <fa-icon [icon]="faChevronRight" class="ml-1 text-sm"></fa-icon>
          </button>
        </div>
      </div>

      }
    </div>
    }
  </div>
</div>

<div class="auth-page auth-mobile-layout">
  <section class="auth-shell" [class.auth-shell--wide]="activeTab === 'register'">
    <div class="auth-hero">
      <a routerLink="/" class="auth-logo-link" aria-label="Volver al inicio">
        <img src="assets/images/ardia.svg" alt="ARDIA" class="auth-logo" />
      </a>

      <div class="auth-hero-copy">
        <h1 class="auth-hero-title">
          La plataforma de
          <span>Agentes Inteligentes,</span>
          conectada a tus datos
        </h1>
        <p class="auth-hero-tagline">Inteligencia artificial para empresas</p>
      </div>
    </div>

    @if(isProcessingMicrosoftLogin) {
    <div class="auth-panel auth-panel--loading">
      <div class="auth-loading-dots" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p class="auth-loading-text">Procesando inicio de sesión con Microsoft...</p>
    </div>
    } @else {
    <div class="auth-panel">
      @if(activeTab !== 'forgot') {
      <div class="auth-tabs" role="tablist" aria-label="Acceso">
        <button type="button" (click)="switchTab('login')" class="auth-tab" [class.is-active]="activeTab === 'login'"
          role="tab" [attr.aria-selected]="activeTab === 'login'">
          Iniciar sesión
        </button>
        <button type="button" (click)="switchTab('register')" class="auth-tab"
          [class.is-active]="activeTab === 'register'" role="tab" [attr.aria-selected]="activeTab === 'register'">
          Crear cuenta
        </button>
      </div>
      } @else {
      <button type="button" (click)="backToLoginFromForgot()" class="auth-back-link">
        Volver al inicio de sesión
      </button>
      }

      @if(activeTab === 'login') {
      <div class="tab-content-animate">
        <div class="auth-heading">
          <h2 class="auth-title">Bienvenido a ARDIA</h2>
          <p class="auth-subtitle">Gestiona tu empresa de forma inteligente.</p>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="login()" class="auth-form"
          aria-labelledby="login-form-heading-mobile">
          <h3 id="login-form-heading-mobile" class="sr-only">Formulario de inicio de sesión</h3>

          <div class="auth-field">
            <label for="username-mobile" class="auth-label">Correo electrónico</label>
            <input id="username-mobile" type="email" required tabindex="1" placeholder="usuario@ardia.es"
              class="auth-input" aria-required="true" formControlName="username" (input)="convertToLowercase($event)"
              style="text-transform: lowercase;" autocomplete="email" />
            <div class="auth-error" aria-live="polite">
              @if(loginForm.controls['username'].invalid && loginForm.controls['username'].touched) {
              Introduce un correo electrónico válido
              }
            </div>
          </div>

          <div class="auth-field">
            <label for="password-mobile" class="auth-label">Contraseña</label>
            <div class="auth-input-wrap">
              <input id="password-mobile" [type]="showPassword ? 'text' : 'password'" required tabindex="2"
                placeholder="••••••••" class="auth-input auth-input--with-action" aria-required="true"
                formControlName="password" autocomplete="current-password" />
              @if (loginForm.get('password')?.value && loginForm.get('password')?.value.length > 0) {
              <button type="button" tabindex="-1" (click)="togglePasswordVisibility()" class="auth-input-action"
                aria-label="Mostrar u ocultar contraseña">
                @if (showPassword) {
                <fa-icon [icon]="faEyeSlash"></fa-icon>
                } @else {
                <fa-icon [icon]="faEye"></fa-icon>
                }
              </button>
              }
            </div>
            <div class="auth-error" aria-live="polite">
              @if(loginForm.controls['password'].invalid && loginForm.controls['password'].touched) {
              @if(loginForm.controls['password'].errors?.['required']) {
              La contraseña es obligatoria
              }
              @else if(loginForm.controls['password'].errors?.['minlength']) {
              La contraseña debe tener al menos 8 caracteres
              }
              }
            </div>
          </div>

          <div class="auth-inline-row">
            <label class="auth-checkbox">
              <input type="checkbox" [(ngModel)]="rememberSession" [ngModelOptions]="{standalone: true}" />
              <span>Recordar sesión</span>
            </label>

            <button type="button" tabindex="6" (click)="switchTab('forgot')" class="auth-link-button"
              aria-label="Recuperar contraseña">
              ¿Olvidaste tu contraseña?
            </button>
          </div>

          <button type="submit" tabindex="3" class="auth-primary-button" aria-label="Iniciar sesión">
            <span>Continuar</span>
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </form>

        <div class="auth-divider">O acceder con</div>

        <div class="auth-social-grid">
          <button type="button" tabindex="4" class="auth-secondary-button" aria-label="Iniciar sesión con Microsoft"
            (click)="loginWithMicrosoft($event)" [disabled]="isMicrosoftLoginLoading">
            @if(isMicrosoftLoginLoading) {
            <div class="auth-button-spinner"></div>
            <span>Conectando...</span>
            } @else {
            <fa-icon [icon]="faMicrosoft" class="text-base"></fa-icon>
            <span>Microsoft</span>
            }
          </button>

          <button type="button" class="auth-secondary-button" disabled>
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
            </svg>
            <span>SSO</span>
          </button>
        </div>

        <div class="auth-section-separator"></div>

        <div class="auth-footer-block">
          <p class="auth-muted-copy">¿Aún no eres cliente?</p>
          <a href="https://outlook.office.com/book/DemoArdia@sdi.es/?ismsaljsauthenabled=true" target="_blank"
            rel="noopener noreferrer" class="auth-outline-button" aria-label="Solicitar demo">
            <span>Solicitar demo</span>
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </a>
        </div>

        <p class="auth-copyright">© ARDIA. Todos los derechos reservados.</p>
      </div>
      } @else if(activeTab === 'register') {
      <div class="tab-content-animate">
        <div class="auth-heading">
          <h2 class="auth-title">Crear cuenta profesional</h2>
          <p class="auth-subtitle">Gestiona tu negocio de forma inteligente en un solo lugar.</p>
        </div>

        <form [formGroup]="registerForm" (ngSubmit)="register()" class="auth-form"
          aria-labelledby="register-form-heading-mobile">
          <h3 id="register-form-heading-mobile" class="sr-only">Formulario de registro</h3>

          <div class="auth-grid-two auth-grid-two--mobile-register">
            <div class="auth-field">
              <label for="reg-name-mobile" class="auth-label">Nombre*</label>
              <input id="reg-name-mobile" type="text" formControlName="name" required placeholder="Tu nombre"
                class="auth-input" />
              <div class="auth-error" aria-live="polite">
                @if(registerForm.get('name')?.invalid && registerForm.get('name')?.touched) { Introduce un nombre válido
                }
              </div>
            </div>

            <div class="auth-field">
              <label for="reg-lastName-mobile" class="auth-label">Apellidos*</label>
              <input id="reg-lastName-mobile" type="text" formControlName="lastName" placeholder="Tus apellidos"
                class="auth-input" />
            </div>

            <div class="auth-field">
              <label for="reg-email-mobile" class="auth-label">Email profesional*</label>
              <input id="reg-email-mobile" type="email" formControlName="email" required autocomplete="email"
                placeholder="ejemplo@empresa.com" (input)="convertRegisterToLowercase($event, 'email')"
                style="text-transform: lowercase;" class="auth-input" />
              <div class="auth-error" aria-live="polite">
                @if(registerForm.get('email')?.invalid && registerForm.get('email')?.touched) { Introduce un correo
                electrónico válido }
              </div>
            </div>

            <div class="auth-field">
              <label for="reg-phone-mobile" class="auth-label">Teléfono*</label>
              <div class="auth-input-wrap">
                <span class="auth-field-icon" aria-hidden="true">
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                  </svg>
                </span>
                <input id="reg-phone-mobile" type="tel" formControlName="phone" required placeholder="+34 600 000 000"
                  class="auth-input auth-input--with-icon" />
              </div>
              <div class="auth-error" aria-live="polite">
                @if(registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched) { El formato del teléfono
                no es válido }
              </div>
            </div>

            <div class="auth-field">
              <label for="reg-companyName-mobile" class="auth-label">Empresa*</label>
              <input id="reg-companyName-mobile" type="text" formControlName="companyName" required
                placeholder="Nombre fiscal" class="auth-input" />
              <div class="auth-error" aria-live="polite">
                @if(registerForm.get('companyName')?.invalid && registerForm.get('companyName')?.touched) { Introduce un
                nombre de empresa válido }
              </div>
            </div>

            <div class="auth-field">
              <label for="reg-nif-mobile" class="auth-label">NIF</label>
              <input id="reg-nif-mobile" type="text" formControlName="nif" required placeholder="A00000000"
                class="auth-input" />
              <div class="auth-error" aria-live="polite">
                @if(registerForm.get('nif')?.invalid && registerForm.get('nif')?.touched) { Introduce un NIF válido }
              </div>
            </div>

            <div class="auth-field">
              <label for="reg-password-mobile" class="auth-label">Contraseña*</label>
              <div class="auth-input-wrap">
                <input id="reg-password-mobile" [type]="showRegisterPassword ? 'text' : 'password'"
                  formControlName="password" required placeholder="••••••••"
                  class="auth-input auth-input--with-action" />
                <button type="button" tabindex="-1" (click)="toggleRegisterPassword()" class="auth-input-action"
                  aria-label="Mostrar u ocultar contraseña">
                  @if(showRegisterPassword) {
                  <fa-icon [icon]="faEyeSlash"></fa-icon>
                  } @else {
                  <fa-icon [icon]="faEye"></fa-icon>
                  }
                </button>
              </div>
            </div>

            <div class="auth-field">
              <label for="reg-passwordConfirmation-mobile" class="auth-label">Confirmar contraseña*</label>
              <div class="auth-input-wrap">
                <input id="reg-passwordConfirmation-mobile" [type]="showRegisterPasswordConfirm ? 'text' : 'password'"
                  formControlName="passwordConfirmation" required placeholder="••••••••"
                  class="auth-input auth-input--with-action" />
                <button type="button" tabindex="-1" (click)="toggleRegisterPasswordConfirm()" class="auth-input-action"
                  aria-label="Mostrar u ocultar contraseña">
                  @if(showRegisterPasswordConfirm) {
                  <fa-icon [icon]="faEyeSlash"></fa-icon>
                  } @else {
                  <fa-icon [icon]="faEye"></fa-icon>
                  }
                </button>
              </div>
              <div class="auth-error" aria-live="polite">
                @if(registerForm.get('passwordConfirmation')?.invalid &&
                registerForm.get('passwordConfirmation')?.touched) {
                @if(registerForm.get('passwordConfirmation')?.errors?.['required']) { Debes confirmar tu contraseña }
                @else if(registerForm.get('passwordConfirmation')?.errors?.['passwordMismatch']) { Las contraseñas no
                coinciden }
                }
              </div>
            </div>
          </div>

          @if (registerForm.get('password')?.value) {
          <div class="space-y-2" aria-live="polite">
            <p class="text-xs font-medium text-[#6B7280]">Requisitos de contraseña:</p>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().minLength"
                [class.bg-red-200]="!getPasswordRequirements().minLength">
                @if (getPasswordRequirements().minLength) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().minLength"
                [class.text-gray-400]="!getPasswordRequirements().minLength">Mínimo 8 caracteres</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasUppercase"
                [class.bg-red-200]="!getPasswordRequirements().hasUppercase">
                @if (getPasswordRequirements().hasUppercase) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasUppercase"
                [class.text-gray-400]="!getPasswordRequirements().hasUppercase">Una mayúscula (A-Z)</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasLowercase"
                [class.bg-red-200]="!getPasswordRequirements().hasLowercase">
                @if (getPasswordRequirements().hasLowercase) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasLowercase"
                [class.text-gray-400]="!getPasswordRequirements().hasLowercase">Una minúscula (a-z)</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasNumber"
                [class.bg-red-200]="!getPasswordRequirements().hasNumber">
                @if (getPasswordRequirements().hasNumber) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasNumber"
                [class.text-gray-400]="!getPasswordRequirements().hasNumber">Un número (0-9)</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasSpecial"
                [class.bg-red-200]="!getPasswordRequirements().hasSpecial">
                @if (getPasswordRequirements().hasSpecial) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasSpecial"
                [class.text-gray-400]="!getPasswordRequirements().hasSpecial">Un carácter especial (!&#64;#$%etc)</span>
            </div>
          </div>
          }

          <div class="auth-legal-row">
            <label class="auth-checkbox auth-checkbox--top" for="acceptTermsLoginMobile">
              <input type="checkbox" formControlName="acceptTerms" id="acceptTermsLoginMobile" />
              <span>
                Acepto las
                <a (click)="openLegalModal($event, 'Condiciones de servicio')" class="auth-inline-link">Condiciones de
                  servicio</a>
                y la
                <a (click)="openLegalModal($event, 'Política de privacidad')" class="auth-inline-link">Política de
                  privacidad</a>.
              </span>
            </label>
            <div class="auth-error" aria-live="polite">
              @if(registerForm.get('acceptTerms')?.invalid && registerForm.get('acceptTerms')?.touched) { Debes aceptar
              las condiciones para continuar }
            </div>
          </div>

          <button type="submit" class="auth-primary-button" [disabled]="isRegistering" aria-label="Registrarse">
            @if(isRegistering) {
            <div class="auth-button-spinner"></div>
            <span>Registrando...</span>
            } @else {
            <span>Continuar</span>
            <fa-icon [icon]="faChevronRight"></fa-icon>
            }
          </button>
        </form>

        <p class="auth-copyright">© ARDIA. Todos los derechos reservados.</p>
      </div>
      } @else if(activeTab === 'forgot') {
      <div class="tab-content-animate">
        @if(!recoveryEmailSent) {
        <div class="auth-heading">
          <p class="auth-eyebrow">Recupera tu acceso</p>
          <h2 class="auth-title">¿Olvidaste tu contraseña?</h2>
          <p class="auth-subtitle">Introduce tu correo y te enviaremos un enlace para restablecerla.</p>
        </div>

        <form [formGroup]="forgotPasswordForm" (ngSubmit)="requestPasswordReset()" class="auth-form">
          <div class="auth-field">
            <label for="forgot-email-mobile" class="auth-label">Correo electrónico</label>
            <input id="forgot-email-mobile" type="email" formControlName="email" required
              placeholder="nombre@empresa.com" class="auth-input" (input)="convertForgotToLowercase($event)"
              style="text-transform: lowercase;" autocomplete="email" />
            <div class="auth-error" aria-live="polite">
              @if(forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched) {
              Introduce un correo electrónico válido
              }
            </div>
          </div>

          <button type="submit" class="auth-primary-button" [disabled]="isSendingRecovery">
            @if(isSendingRecovery) {
            <div class="auth-button-spinner"></div>
            <span>Enviando...</span>
            } @else {
            <span>Continuar</span>
            <fa-icon [icon]="faChevronRight"></fa-icon>
            }
          </button>
        </form>
        } @else {
        <div class="auth-message-card">
          <div class="auth-message-icon" aria-hidden="true">
            <svg class="h-7 w-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
            </svg>
          </div>
          <h2 class="auth-title auth-title--compact">Revisa tu correo</h2>
          <p class="auth-subtitle auth-subtitle--center">Hemos enviado un enlace de recuperación a:</p>
          <p class="auth-highlighted-copy">{{ recoveryEmail }}</p>
          <p class="auth-muted-copy">Si no lo recibes en unos minutos, revisa la carpeta de spam.</p>
        </div>
        }
      </div>
      }
    </div>
    }
  </section>
</div>

@if (showLegalModal) {
<app-legal-modal [title]="legalModalTitle" (close)="showLegalModal = false"></app-legal-modal>
}
